import { atomWithStorage, createJSONStorage } from 'jotai/utils';

// localStorageを使用するatom
const storage = createJSONStorage(() => localStorage);

export const selectedSearchResultAtom = atomWithStorage(
  'selectedSearchResult',  // ストレージキー
  null,                    // 初期値
  storage                  // ストレージプロバイダ
);

export const searchCondAtom = atomWithStorage(
  'searchConditions',    // ストレージキー
  {},                    // 初期値
  storage                // ストレージプロバイダ
);

// 明示的なロード関数（別タブで使用）
export const loadSearchResultFromStorage = () => {
  try {
    const storedValue = localStorage.getItem('selectedSearchResult');
    return storedValue ? JSON.parse(storedValue) : null;
  } catch (error) {
    console.error('Error loading from localStorage:', error);
    return null;
  }
};